import { createFileRoute } from '@tanstack/react-router';

import { ReportPricingPage } from '@/features/settings/ReportPricingPage';

export const Route = createFileRoute('/admin/_app/platform-settings/report-pricing')({
  component: ReportPricingPage,
});
